import React, { FC } from 'react';
import { Link } from 'react-router5';

import { UnitLinkProps } from './UnitLink.interface';
import { PROFILE, RESOLVE } from '$shared/constants/pages';

export const UnitLink: FC<UnitLinkProps> = ({ unit, children, className, target }) => {
  if (unit) {
    return (
      <Link
        target={target}
        className={className}
        routeName={unit.domain ? RESOLVE : PROFILE}
        routeParams={unit.domain ? { domain: unit.domain } : { id: unit.id }}
      >
        {children}
      </Link>
    );
  } else {
    return <div className={className}>{children}</div>;
  }
};
